module.exports = __webpack_public_path__ + "img/gift-workmate-top.2efdd161.png";